import React, { useState, useEffect } from "react";

//Importar custom hooks y helpers.
import useDragAndDrop from "../../../../../hooks/useDragAndDrop.js";
import { handleDropFile } from "../../../../../helpers/multimedia/handleDropFile.js";

//Importar íconos de Material UI.
import BtnSendMessage from "./BtnSendMessage.jsx";
import PreviewByFileType from "./PreviewByFileType.jsx";
import PreviewMiniFileSelected from "./PreviewMiniFileSelected.jsx";
import BtnActionModal from "../../../../common/Buttons/BtnActionModal.jsx";
import WriteMessageInPreviewFile from "./WriteMessageInPreviewFile.jsx";
import { Close } from '@mui/icons-material/';
import useFilePaste from "../../../../../hooks/useFilePaste.js";

// PreviewFileSelected: Componente que renderiza la vista previa de los contenidos multimedia 
// seleccionados o arrastrados en el chat.

const PreviewFileSelected = ({ typeFile, filesSelected, setFilesSelected, sessionSelected, setOpenMessageFileSize, messagesArray, setMessagesArray, handleClosePreview }) => {

    const [mensaje, setMensaje] = useState('');  //Estado para actualizar el mensaje a enviarse junto con el archivo.
    const [fileSelected, setFileSelected] = useState(""); //Estado para actualizar el nombre del archivo seleccionado.
    const [fileType, setFileType] = useState(""); //Estado para actualizar el tipo de archivo seleccionado.
    const [keyDownSendMessage, setKeyDownSendMessage] = useState(""); //Estado para ejecutar el useEffect dentro del botón de enviar mensaje.

    const onLastFileSelected = () => {//Función para seleccionar el último archivo dentro de los archivos seleccionados.
        //Actualizar el archivo seleccionado con el último dentro del arreglo.
        if (filesSelected.length > 0) setFileSelected(filesSelected[filesSelected.length - 1].name);
    };

    const onHandleDrop = (files) => { //Función para manejar el arrastre de archivos al Chat.
        console.log("este es el file que recibí para pegar", files, "y esto tiene el array de files", filesSelected);
        const fileType__toDrop = handleDropFile(files, filesSelected, setFilesSelected, fileType, setOpenMessageFileSize);
        setFileType(fileType__toDrop); //Actualizar el estado que contiene el tipo de archivo.
    };

    const handleKeyDown = (e) => { //Función para enviar un mensaje al presionar enter en el campo para escribir.
        console.log("esto es el kewDown", e)
        if (e.key === 'Enter' && !e.shiftKey) { //Si los eventos del teclado no incluyen el Enter + Shift
            e.preventDefault();
            setKeyDownSendMessage("enviar"); //Actualiza el estado a "enviar" el mensaje.
        }
    };

    useFilePaste({ filesSelected, setFilesSelected, setOpenMessageFileSize, setFileType }); //Se ejecuta cuándo se pega un archivo multimedio (Ctrl + v)

    //Se ejecuta cada vez que cambia la lista de archivos seleccionados.
    useEffect(() => onLastFileSelected(), [filesSelected]);

    //Función que se ejecuta al seleccionar un tipo de archivo dentro del menú de subir archivos.
    useEffect(() => setFileType(typeFile), [typeFile]);

    //Custom Hook para importar funciones para el arrastrar y soltar archivos multimedias.
    const { dropAreaRef, handleDragOver, handleDragLeave, handleDrop } = useDragAndDrop(onHandleDrop);

    return (
        <>
            {filesSelected.length > 0 && <div className="container-selected-file"
                ref={dropAreaRef} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>

                {/*------Contenedor del boton para cerrar la vista previa----- */}
                <div className='container-selected-file__btn--close' >
                    <BtnActionModal setFilesSelected={setFilesSelected} onClick={handleClosePreview} >
                        <Close sx={{ fontSize: "22px" }} />
                    </BtnActionModal>
                </div>

                {/*------Contenedor con el Preview de la imagen----------*/}
                <div className="container-img__preview">
                    {filesSelected.length > 0 && (
                        <div className="container-img-preview" >
                            {/*-------------Contenedor miniatura individual----------*/}
                            <PreviewByFileType fileType={fileType} filesSelected={filesSelected}
                                fileSelected={fileSelected} />
                        </div>
                    )}
                </div>

                {/*------Contenedor con el nombre del archivo----------*/}
                <div className="container-selected-file__name">
                    <span>{fileSelected}</span>
                </div>

                {/*------Contenedor con la imagen miniatura----------*/}
                <PreviewMiniFileSelected fileType={fileType} filesSelected={filesSelected} setOpenMessageFileSize={setOpenMessageFileSize}
                    setFilesSelected={setFilesSelected} fileSelected={fileSelected} setFileSelected={setFileSelected} />

                {/*---------Contenedor del campo para escribir y enviar un mensaje------------*/}
                <div className="container-chat__textArea preview__img">

                    <WriteMessageInPreviewFile messagesArray={messagesArray} setMessagesArray={setMessagesArray} handleKeyDown={handleKeyDown}
                        fileSelected={fileSelected} />

                    <BtnSendMessage setMensaje={setMensaje} type={fileType} messagesArray={messagesArray} mensaje={mensaje} 
                    sessionSelected={sessionSelected} filesSelected={filesSelected} handleClosePreview={handleClosePreview} 
                    keyDownSendMessage={keyDownSendMessage} setKeyDownSendMessage={setKeyDownSendMessage} />
                </div>

            </div>}
        </>
    )
};

export default PreviewFileSelected;